// Module
var code = `{{#if colorPickerProps}}
    <ColorPickerScreen 
        parentContainerControl="{{@this}}"
        colorFromProps="{{colorPickerProps.color}}"
        xFromProps="{{colorPickerProps.x}}"
        yFromProps="{{colorPickerProps.y}}"
        onColorPicked="{{colorPickerProps.onColorChangedCallback}}"
        onCloseColorPicker="{{colorPickerProps.onCloseColorPicker}}"
        parentLoc="{{colorPickerProps.parentLoc}}"
    />
{{/if}}`;
// Exports
export default code;